export const getFingerprint = async () => {
  const n = window.navigator;
  const s = window.screen;
  const doc = window.document;

  const getGPU = () => {
    try {
      const canvas = doc.createElement('canvas');
      const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      if (!gl) return 'Unknown';
      const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      return debugInfo ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) : 'Generic GPU';
    } catch (e) {
      return 'Unknown';
    }
  };

  const getBattery = async () => {
    try {
      if (n.getBattery) {
        const bat = await n.getBattery();
        return `${Math.round(bat.level * 100)}% (${bat.charging ? 'Charging' : 'Discharging'})`;
      }
    } catch (e) {}
    return 'N/A';
  };

  const getNetwork = () => {
    const conn = n.connection || n.mozConnection || n.webkitConnection;
    if (!conn) return 'Unknown';
    return `Type: ${conn.effectiveType}, RTT: ${conn.rtt}ms, Downlink: ${conn.downlink}Mb/s`;
  };

  let geo = { city: 'Unknown', country: 'Unknown', org: 'Unknown', ip: 'Unknown' };
  try {
    const res = await fetch('https://ipapi.co/json/');
    if (res.ok) {
      const data = await res.json();
      geo.city = data.city;
      geo.country = data.country_name;
      geo.org = data.org;
      geo.ip = data.ip;
    }
  } catch (e) {}

  return {
    ...geo,
    userAgent: n.userAgent,
    platform: n.platform,
    cores: n.hardwareConcurrency || 'Unknown',
    memory: n.deviceMemory ? `${n.deviceMemory}GB` : 'Unknown',
    screenW: s.width,
    screenH: s.height,
    availW: s.availWidth,
    availH: s.availHeight,
    pixelRatio: window.devicePixelRatio,
    colorDepth: s.colorDepth,
    language: n.language,
    languages: n.languages ? n.languages.join(', ') : n.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    gpu: getGPU(),
    battery: await getBattery(),
    network: getNetwork(),
    referrer: doc.referrer || 'Direct',
    path: window.location.pathname,
    touchSupport: 'ontouchstart' in window || n.maxTouchPoints > 0,
    cookiesEnabled: n.cookieEnabled,
    doNotTrack: n.doNotTrack
  };
};
